"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memo = void 0;
var contextRemainingDepth = 10;

function memo(builder) {
  var previous = {};
  return function (maxDepth) {
    var n = maxDepth !== undefined ? maxDepth : contextRemainingDepth;

    if (!Object.prototype.hasOwnProperty.call(previous, n)) {
      var prev = contextRemainingDepth;
      contextRemainingDepth = n - 1;
      previous[n] = builder(n);
      contextRemainingDepth = prev;
    }

    return previous[n];
  };
}

exports.memo = memo;